
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1612d_1i16w_179",
  "spinner-rotator": "awsui_spinner-rotator_1612d_1i16w_1",
  "size-x-small": "awsui_size-x-small_1612d_1i16w_193",
  "size-normal": "awsui_size-normal_1612d_1i16w_201",
  "size-big": "awsui_size-big_1612d_1i16w_209",
  "size-large": "awsui_size-large_1612d_1i16w_217",
  "variant-normal": "awsui_variant-normal_1612d_1i16w_225",
  "variant-disabled": "awsui_variant-disabled_1612d_1i16w_228",
  "variant-inverted": "awsui_variant-inverted_1612d_1i16w_231",
  "circle": "awsui_circle_1612d_1i16w_246",
  "circle-left": "awsui_circle-left_1612d_1i16w_274",
  "spinner-line-left": "awsui_spinner-line-left_1612d_1i16w_1",
  "circle-right": "awsui_circle-right_1612d_1i16w_279",
  "spinner-line-right": "awsui_spinner-line-right_1612d_1i16w_1"
};
  